<div class="page_offer">

    <div class="row marges page_offer_row_sticky_top">

        <!-- Retour -->

        @if(listRedirectionAllowed) {
            <div class="col y_items_center">
                @if(isOneOfTheseViews(['date-engine', 'booking-request'])) {
                    <div class="back_to_list" style="border-bottom: 0; padding-bottom: 0">
                        <span class="ty-chevron" (click)="redirectToList()">{{ backToListLabel | translate }}</span>
                    </div>
                }
            </div>
        }

        <!-- Action sur le catalogue -->

        @if(hasAccessOfferCreatorRead) {

            <div class="col_content y_items_center">
                <a [routerLink]="['/account/offer-creator/read', offer.society.id]" [target]="'_blank'" [queryParams]="{ 'list-redirection-allowed': 0 }" class="btn_cta btn_little btn_green_lines">
                    {{ 'offer.list.item.action.offerCreator.profile.value' | translate }}
                </a>
            </div>
        }

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

            @if(isAcceptedOfferCatalog && userService.isCurrentUserWithAccess('OFFER_CATALOG_DELETE_IS_MINE')) {

                <div class="col_content y_items_center">
                    <button (click)="openDeleteCatalogueDialog()" class="btn_cta btn_little">
                        {{ 'offer.list.item.action.catalog.delete.value' | translate }}
                    </button>
                </div>
            }

            @if(isRefusedOfferCatalog) {

                <div class="col_content y_items_center">
                    <button [disabled]="true" class="btn_cta btn_little">
                        {{ 'offer.accessRequest.refused.value' | translate }}
                    </button>
                </div>
            }

            @if(!offer.inCatalog && !offer.catalog) {

                <div class="col_content y_items_center">
                    <button (click)="addOfferInCatalog()" class="btn_cta btn_little" [ngClass]="{ 'disabled': !userService.hasAccess(user, 'OFFER_CATALOG_CREATE') }" matTooltip="{{ 'offer.list.item.action.access.request.disabled.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="userService.hasAccess(user, 'OFFER_CATALOG_CREATE')">
                        {{ 'offer.list.item.action.access.request.value' | translate }}
                    </button>
                </div>
            }
        }

    </div>

    @switch (true) {

        <!-- Demande de réservation | Demande de devis -->

        @case (isView('booking-request')) {
            <ng-container *ngTemplateOutlet="bookingRequestTemplate"></ng-container>
        }

        <!-- Offrir -->

        @case (isView('gift-voucher-request')) {
            <ng-container *ngTemplateOutlet="giftVoucherRequestTemplate"></ng-container>
        }
    }

    <!-- Détails de l'offre -->

    @if(isOneOfTheseViews(['date-engine', 'booking-request'])) {

        <app-core-offer-item [isMine]="isMine" [roles]= "roles" [item]="offer" [configuration]="configuration" (onLocaleUpdated)="updateLocale($event)">

            <!-- Projection de contenu pour la composition -->

            <div compositionContent [hidden]="!isView('date-engine')">

                <ng-container *ngTemplateOutlet="dateEngineTemplate"></ng-container>

            </div>

            <!-- Projection de contenu pour les options -->

            <div optionsContent>
                @if(options$ | async; as options) {

                    @if(options.length > 0) {

                        <div class="txt_offer">
                            <p class="title">{{ 'offer.stay.personalization.value' | translate}}</p>
                        </div>

                        @for((option of options$ | async); track option) {

                            <div class="option_offer">
                                <div class="option">
                                    <div class="row">
                                        @if(option.image?.image) {
                                            <div class="col_3">
                                                <div class="visuel">
                                                    <img [src]="option.image.image | imageSource: 'rectangle' : 200 : 90" alt="{{ translationService.getFallbackTranslation(option.translations).title }}" title="{{ translationService.getFallbackTranslation(option.translations).title }}" />
                                                </div>
                                            </div>
                                        }
                                        <div class="col_9">
                                            <div class="infos">
                                                <div class="txt_offer">
                                                    <p class="title">{{ translationService.getFallbackTranslation(option.translations).title }}</p>
                                                    <div [innerHTML]="translationService.getFallbackTranslation(option.translations).description|safeHtml"></div>
                                                </div>
                                                <div class="row marges x_between">

                                                    @if(offerOptionSelectionService.hasItem(option)) {

                                                        <!-- Typologie Individuel -->

                                                        @if(offer.customerTypology.type === 'I') {

                                                            <div class="col y_items_center">

                                                                <div class="row marges">

                                                                    <!-- Public Adulte -->

                                                                    @if(isPublicAvailable(option, 'adult')) {

                                                                        <div class="col_4 y_items_center">
                                                                            <div class="form-group">
                                                                                <select [value]="option.nbAdult" (change)="handleOptionPresential(option, 'adult', $event)">
                                                                                    @for(count of getChoicePresentialOptionValues(option.presentialIndividual, 'adult'); track count) {
                                                                                        <option [ngValue]="count" [selected]="count === option.nbAdult">{{ count }}</option>
                                                                                    }
                                                                                </select>
                                                                                <label>{{ (offerOptionSelectionService.getItemById(option.id).nbAdult > 1 ? 'offer.option.nbAdult.plural.value' : 'offer.option.nbAdult.value')|translate:{ count : offerOptionSelectionService.getItemById(option.id).nbAdult } }}</label>
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                    <!-- Public Enfant -->

                                                                    @if(isPublicAvailable(option, 'child')) {

                                                                        <div class="col_4 y_items_center">
                                                                            <div class="form-group">
                                                                                <select [value]="option.nbChild" (change)="handleOptionPresential(option, 'child', $event)">
                                                                                    @for(count of getChoicePresentialOptionValues(option.presentialIndividual, 'child'); track count) {
                                                                                        <option [ngValue]="count" [selected]="count === option.nbChild">{{ count }}</option>
                                                                                    }
                                                                                </select>
                                                                                <label>
                                                                            <span>
                                                                                {{ (offerOptionSelectionService.getItemById(option.id).nbChild > 1 ? 'offer.option.nbChild.plural.value' : 'offer.option.nbChild.value')|translate:{ count : offerOptionSelectionService.getItemById(option.id).nbChild } }}
                                                                                @if(!offer.onRequest) {
                                                                                    <span class="green">{{ 'offer.presential.child.age.interval.value'|translate:{min : option.minChildrenAge, max : option.maxChildrenAge} }}</span>
                                                                                }
                                                                            </span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                </div>

                                                            </div>
                                                        }

                                                        <!-- Typologie Groupe -->

                                                        @if(offer.customerTypology.type === 'G') {

                                                            <div class="col y_items_center">

                                                                <div class="row marges">

                                                                    <!-- Public Adulte -->

                                                                    @if(isPublicAvailable(option, 'adult')) {
                                                                        <div class="col_4 y_items_center">
                                                                            <div class="form-group">
                                                                                <select [value]="option.nbAdult" (change)="handleOptionPresential(option, 'adult', $event)">
                                                                                    @for(count of getChoicePresentialOptionValues(option.presentialGroup, 'adult'); track count) {
                                                                                        <option [ngValue]="count" [selected]="count === option.nbAdult">{{ count }}</option>
                                                                                    }
                                                                                </select>
                                                                                <label>{{ (offerOptionSelectionService.getItemById(option.id).nbAdult > 1 ? 'offer.option.nbAdult.plural.value' : 'offer.option.nbAdult.value')|translate:{ count : offerOptionSelectionService.getItemById(option.id).nbAdult } }}</label>
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                    <!-- Public Enfant -->

                                                                    @if(isPublicAvailable(option, 'child')) {
                                                                        <div class="col_4 y_items_center">
                                                                            <div class="form-group">
                                                                                <select [value]="option.nbChild" (change)="handleOptionPresential(option, 'child', $event)">
                                                                                    @for(count of getChoicePresentialOptionValues(option.presentialGroup, 'child'); track count) {
                                                                                        <option [ngValue]="count" [selected]="count === option.nbChild">{{ count }}</option>
                                                                                    }
                                                                                </select>
                                                                                <label>
                                                                        <span>
                                                                            {{ (offerOptionSelectionService.getItemById(option.id).nbChild > 1 ? 'offer.option.nbChild.plural.value' : 'offer.option.nbChild.value')|translate:{ count : offerOptionSelectionService.getItemById(option.id).nbChild } }}
                                                                            @if(!offer.onRequest) {
                                                                                <span class="green">{{ 'offer.presential.child.age.interval.value'|translate:{min : option.minChildrenAge, max : option.maxChildrenAge} }}</span>
                                                                            }
                                                                        </span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        }

                                                        <!-- Choix du jour -->

                                                        @if(option.availableByDay) {
                                                            <div class="col_2 y_items_center">
                                                                <div class="form-group">
                                                                    <select [value]="option.day" (change)="handleOptionDay(option, $event)">
                                                                        @for(count of choiceDayOptionValues; track count) {
                                                                            <option [ngValue]="count" [selected]="count === option.day">{{ count }}</option>
                                                                        }
                                                                    </select>
                                                                    <label>{{ 'offer.option.day.value'|translate }} <span>{{ offerOptionSelectionService.getItemById(option.id).day }}</span></label>
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row x_end check_option">
                                    <div class="col_content">
                                        <div class="form-group">
                                            <div class="checkbox">
                                                <input type="checkbox" id="startFromPrice-{{option.id}}" (change)="handleOptionSelection(option)">
                                                <label for="startFromPrice-{{option.id}}">
                                                    <span>{{ 'offer.option.startFromPrice.value' | translate: { price: ((option.startFromPrice / 100) | parsePrice), currency: option.startFromCurrency.symbol, type: ((offer.isDisplayPriceHT ? 'offer.price.type.ht.value' : 'offer.price.type.ttc.value') | translate) } }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                }
            </div>

        </app-core-offer-item>
    }

</div>

<ng-template #dateEngineTemplate>

    <div class="choice_date">

        <!-- Moteur de date -->

        <div class="row marges">

            <div class="col_12">
                <app-core-offer-date-engine [childDatesAllowed]="childDatesOffer" [currentUser]="user" [offer]="offer" [configuration]="offerDateEngineConfiguration" [loadItemsSourceCallback]="loadItemsSourceCallback" [loadFirstAvailabilityItemSourceCallback]="loadFirstAvailabilityItemSourceCallback"></app-core-offer-date-engine>
            </div>

        </div>

        @if(offer.inCatalog && bookingSummaryService.item) {

            <div class="row marges x_end">
                <div class="col_12">
                    <div class="recap_date">

                        <!-- Options -->

                        @for(bookingCompositionOption of bookingSummaryService.item.composition.options; track bookingCompositionOption) {

                            <div class="row marges">
                                <div class="col y_items_start">
                                    <span class="name">{{ translationService.getFallbackTranslation(bookingCompositionOption.option.translations).title }}</span>
                                </div>
                                <div class="col_content y_items_start">
                                <span class="price">
                                    {{ (bookingCompositionOption.priceTTC / 100) | parsePrice }} {{ offer.currency.symbol }} {{ 'offer.price.type.ttc.value'|translate }}

                                    @if(bookingCompositionOption.priceHT) {
                                        <span class="price-ht">
                                            ({{ (bookingCompositionOption.priceHT / 100) | parsePrice }} {{ offer.currency.symbol }}  {{ 'offer.price.type.ht.value'|translate }})
                                        </span>
                                    }

                                </span>
                                </div>
                            </div>
                        }

                        <!-- Total -->

                        @if(bookingSummaryService.item.composition && bookingSummaryService.item.type === 'booking') {

                            <div class="row marges total">
                                <div class="col x_end y_items_end">
                                    <span class="name">{{ 'stay.price.total.value' | translate }}</span>
                                </div>
                                <div class="col_content x_end y_items_end">
                                    <div>
                                        @if(bookingSummaryService.item.composition.promotionPriceTTC < bookingSummaryService.item.composition.priceTTC) {
                                            <span class="price">
                                                <span class="old_price">
                                                    {{ (bookingSummaryService.item.composition.priceTTC / 100) | parsePrice }} {{ offer.currency.symbol }} {{ 'offer.price.type.ttc.value'|translate }}
                                                    @if(bookingSummaryService.item.composition.priceHT) {
                                                        <span class="price-ht">
                                                            ({{ (bookingSummaryService.item.composition.priceHT / 100) | parsePrice }} {{ offer.currency.symbol }}  {{ 'offer.price.type.ht.value'|translate }})
                                                        </span>
                                                    }
                                                </span>
                                            </span>
                                        }
                                        <span class="price">
                                            {{ (bookingSummaryService.item.composition.promotionPriceTTC / 100) | parsePrice }} {{ offer.currency.symbol }} {{ 'offer.price.type.ttc.value'|translate }}
                                            @if(bookingSummaryService.item.composition.promotionPriceHT) {
                                                <span class="price-ht">
                                                    ({{ (bookingSummaryService.item.composition.promotionPriceHT / 100) | parsePrice }} {{ offer.currency.symbol }}  {{ 'offer.price.type.ht.value'|translate }})
                                                </span>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        @if(isAcceptedOfferCatalog) {

            <div class="row {{ userService.hasAccess(user, 'BOOKING_CREATE_IS_MINE') ? 'x_end' : 'x_start' }} validate_date">

                @if(hasGiftVoucherEnable && !isView('gift-voucher-request')) {

                    <!-- Bon cadeau -->

                    <button type="button" class="btn_cta btn_lines btn_little" (click)="validateGiftVoucherRequest()">
                        {{ 'offer.gift.value' | translate }}
                    </button>
                }

                @if(userService.hasAccess(user, 'BOOKING_CREATE_IS_MINE')) {

                    <!-- Demande de réservation -->

                    <button type="button" class="btn_cta btn_little btn_booking" [disabled]="(!offerDateEngineComponent?.valid) || (offerDateEngineComponent?.item.type !== 'booking')" (click)="validateBookingRequest('booking')">
                        {{ bookingRequestLabel }}
                    </button>

                    @if(offer.isAllowBookingRequest) {

                        <!-- Demande de devis -->

                        <button type="button" class="btn_cta btn_little btn_booking" [disabled]="!offerDateEngineComponent?.valid" (click)="validateBookingRequest('request')">
                            {{ quotationRequestLabel }}
                        </button>
                    }
                }

            </div>
        }

    </div>

</ng-template>

<ng-template #bookingRequestTemplate>

    <app-core-offer-booking-request-create [offer]="offer" [currentUser]="user" [termsAndConditions]="termsAndConditions" [compositionItem]="compositionItem" [hasPermanentOptionsAvailable]="hasPermanentOptionsAvailable" [viewLanguage]="locale" (backToCompositionRequested)="handleBackToComposition()" (permanentOptionsSelectionCleared)="handlePermanentOptionSelectionClear()" (promotionApplied)="handlePromotionSelection($event)">

        <!-- Projection de contenu pour les options permanentes -->

        @if((permanentOptions$ | async)?.length > 0) {

            <div permanentOptionsContent>

                @if(compositionItem.type === 'booking') {
                    <div class="txt_offer">
                        <p class="title">{{ 'offer.permanentOptions.value' | translate}}</p>
                    </div>
                }

                @for((permanentOption of permanentOptions$ | async); track permanentOption) {

                    <div class="option_offer">
                        <div class="option">
                            <div class="row">
                                @if(translationService.getFallbackTranslation(permanentOption.translations).picture?.image) {
                                    <div class="col_3">
                                        <div class="visuel">
                                            <img [src]="translationService.getFallbackTranslation(permanentOption.translations).picture.image | imageSource: 'rectangle' : 200 : 90" alt="{{ translationService.getFallbackTranslation(permanentOption.translations).title }}" />
                                        </div>
                                    </div>
                                }
                                <div class="col_9">
                                    <div class="infos">
                                        <div class="txt_offer">
                                            <p class="title x_between_lg">
                                                {{ translationService.getFallbackTranslation(permanentOption.translations).title }}
                                                @if(getSummaryPermanentOption(permanentOption.id)) {
                                                    @if(!!getSummaryPermanentOption(permanentOption.id).priceTTC) {
                                                        <span>{{ (getSummaryPermanentOption(permanentOption.id).priceTTC / 100) | parsePrice }}{{ offer.currency.symbol }} {{ 'offer.displayPrice.ttc.value' | translate }}</span>
                                                    }
                                                    @if(getSummaryPermanentOption(permanentOption.id).onRequest) {
                                                        <span>{{ 'offer.booking.permanentOptions.onRequest' | translate }}</span>
                                                    }
                                                }
                                            </p>
                                            <div [innerHTML]="translationService.getFallbackTranslation(permanentOption.translations).description|safeHtml"></div>
                                        </div>
                                        <div class="x_end">
                                            <p>
                                                <a class="terms_and_condition" (click)="openOfferPermanentOptionFileInNewTab(translationService.getFallbackTranslation(permanentOption.translations).termsAndConditions)" target="_blank">{{ 'offer.permanentOptions.termsAndConditions.value' | translate }}</a>

                                                @if(translationService.getFallbackTranslation(permanentOption.translations).additionalDocument) {
                                                    - <a class="terms_and_condition" (click)="openOfferPermanentOptionFileInNewTab(translationService.getFallbackTranslation(permanentOption.translations).additionalDocument)" target="_blank">{{ 'offer.permanentOptions.additionalDocument.value' | translate }}</a>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row x_end check_option">
                            <div class="col_content">
                                <div class="form-group">
                                    <div class="checkbox">
                                        <input type="checkbox" id="permanentOptionStartFromPrice-{{permanentOption.id}}" (change)="handlePermanentOptionSelection(permanentOption)">
                                        <label for="permanentOptionStartFromPrice-{{permanentOption.id}}">
                                            <span>{{ 'offer.permanentOption.select.value' | translate }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </app-core-offer-booking-request-create>

</ng-template>

<ng-template #giftVoucherRequestTemplate>
    <app-offer-gift-voucher-request-create (backToOfferRequested)="setView('date-engine')" [offer]="offer" [currentUser]="user" [termsAndConditions]="termsAndConditions" ></app-offer-gift-voucher-request-create>
</ng-template>
